import {
  setInLocalStorage,
  getFromLocalStorage,
  LocalStorageKeys,
} from "./localStorage";

export const hasTourBeenCompleted = () =>
  !!getFromLocalStorage(LocalStorageKeys.HasUsedHelp);

export const setTourToComplete = () =>
  setInLocalStorage(LocalStorageKeys.HasUsedHelp, true);
